import * as React from "react";
import RowCheckbox from "components/common/EntityDataTable/RowCheckbox";
import useSelectedMessageEntities from "views/hooks/useSelectedMessageEntities";
const BulkSelectHead = ({ data }) => {
  const { toggleAllEntitySelect, isAllRowsSelected, isSomeRowsSelected } = useSelectedMessageEntities();
  const title = `${isAllRowsSelected ? "Deselect" : "Select"} all visible messages`;
  const onBulkSelect = () => toggleAllEntitySelect(data);
  return /* @__PURE__ */ React.createElement(
    RowCheckbox,
    {
      indeterminate: isSomeRowsSelected,
      onChange: onBulkSelect,
      checked: isAllRowsSelected,
      title,
      disabled: !data.length,
      "aria-label": title
    }
  );
};
export default BulkSelectHead;
